import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-group"
}
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "mb-2 text-danger fw-bold" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "w-25 ps-2"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "form-group col-md-6" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "lowTitle" }
const _hoisted_15 = { class: "form-group col-md-4" }
const _hoisted_16 = { class: "form-group col-md-8" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_input = _resolveComponent("localized-input")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_sesso = _resolveComponent("sesso")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_op_address = _resolveComponent("op-address")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_localized_input, {
      labelKey: "Nome",
      labelValue: "Nome",
      placeholderKey: "Nome",
      placeholderValue: "Nome",
      modelValue: _ctx.localValue.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.name) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_localized_input, {
      labelKey: "Cognome",
      labelValue: "Cognome",
      placeholderKey: "Cognome",
      placeholderValue: "Cognome",
      modelValue: _ctx.localValue.surname,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.surname) = $event))
    }, null, 8, ["modelValue"]),
    (_ctx.needsFiscalCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Sesso",
              text: "Sesso"
            })
          ]),
          _createVNode(_component_sesso, {
            modelValue: _ctx.localValue.sex,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.sex) = $event))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.needsFiscalCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Codice Fiscale",
                text: "Codice Fiscale"
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.codFiscError)
                ? (_openBlock(), _createBlock(_component_localized_text, {
                    key: 0,
                    localizedKey: "Codice fiscale non valido",
                    text: "Codice fiscale non valido"
                  }))
                : _createCommentVNode("", true),
              (_ctx.codFiscNonCoerente)
                ? (_openBlock(), _createBlock(_component_localized_text, {
                    key: 1,
                    localizedKey: "Il codice fiscale inserito non è coerente con gli altri dati",
                    text: "Il codice fiscale inserito non è coerente con gli altri dati"
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control text-uppercase", _ctx.$store.state.isCordova ? 'w-75' : 'w-100']),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.fiscalCode) = $event)),
                placeholder: _ctx.$localizationService.GetLocalizedValue('Codice fiscale', 'Codice fiscale')
              }, null, 10, _hoisted_6), [
                [_vModelText, _ctx.localValue.fiscalCode]
              ]),
              (_ctx.$store.state.isCordova)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startScan && _ctx.startScan(...args)))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Scan",
                        text: "Scan"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Partita iva",
            text: "Partita iva"
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_toggler, {
            modelValue: _ctx.localValue.hasVat,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localValue.hasVat) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    (_ctx.localValue.hasVat)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_localized_input, {
              class: "col-md-8",
              labelKey: "Ragione sociale",
              labelValue: "Ragione sociale",
              placeholderKey: "Ragione sociale",
              placeholderValue: "Ragione sociale",
              modelValue: _ctx.localValue.companyName,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localValue.companyName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_localized_input, {
              class: "col-md-4",
              labelKey: "Numero partita iva",
              labelValue: "Numero partita iva",
              placeholderKey: "Numero partita iva",
              placeholderValue: "Numero partita iva",
              modelValue: _ctx.localValue.vatNumber,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localValue.vatNumber) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_localized_input, {
              class: "col-md-4",
              labelKey: "Codice destinatario",
              labelValue: "Codice destinatario",
              placeholderKey: "Codice destinatario",
              placeholderValue: "Codice destinatario",
              modelValue: _ctx.localValue.codiceDestinatario,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localValue.codiceDestinatario) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_localized_input, {
              class: "col-md-8",
              labelKey: "Pec",
              labelValue: "Pec",
              placeholderKey: "Pec",
              placeholderValue: "Pec",
              modelValue: _ctx.localValue.pec,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localValue.pec) = $event))
            }, null, 8, ["modelValue"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.needsFiscalCode)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_localized_text, {
                localizedKey: "Luogo e data di nascita",
                text: "Luogo e data di nascita"
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Data di nascita",
                  text: "Data di nascita"
                })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: "form-control",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.alertLuogoDataNascita && _ctx.alertLuogoDataNascita(...args)))
                }, [
                  (_ctx.localValue.dataNascita)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$filters.date(_ctx.localValue.dataNascita, 'DD/MM/YYYY')), 1)
                      ], 64))
                    : (_openBlock(), _createBlock(_component_localized_text, {
                        key: 1,
                        localizedKey: "gg/mm/aaaa",
                        text: "gg/mm/aaaa"
                      }))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Luogo di nascita",
                  text: "Luogo di nascita"
                })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: "form-control",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.alertLuogoDataNascita && _ctx.alertLuogoDataNascita(...args)))
                }, [
                  (_ctx.localValue.dataNascita)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.localValue.luogoNascita), 1)
                      ], 64))
                    : (_openBlock(), _createBlock(_component_localized_text, {
                        key: 1,
                        localizedKey: "Luogo di nascita",
                        text: "Luogo di nascita"
                      }))
                ])
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_17,
    _createVNode(_component_op_address, {
      class: "mt-2",
      modelValue: _ctx.localValue.fiscalAddress,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.localValue.fiscalAddress) = $event)),
      label: "Indirizzo residenza"
    }, null, 8, ["modelValue"])
  ]))
}